import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../utils/api';
import { FaChevronLeft, FaChevronRight, FaCalendarAlt } from 'react-icons/fa';

const TopDiscountBanner = () => {
  const [banners, setBanners] = useState([]);
  const [index, setIndex] = useState(0);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const timerRef = useRef(null);

  useEffect(() => {
    let cancelled = false;
    api
      .get('/banners/active')
      .then((res) => {
        if (!cancelled) setBanners(res.data?.data || []);
      })
      .catch(() => {
        if (!cancelled) setBanners([]);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
      if (timerRef.current) clearInterval(timerRef.current);
    };
  }, []);

  useEffect(() => {
    if (banners.length > 1) {
      timerRef.current = setInterval(() => {
        setIndex((prev) => (prev + 1) % banners.length);
      }, 5000);
    }
    return () => {
      if (timerRef.current) clearInterval(timerRef.current);
    };
  }, [banners.length]);

  if (loading || banners.length === 0) return null;
  const banner = banners[index];

  const backgroundStyle = banner.image?.url
    ? {
        backgroundImage: `linear-gradient(rgba(0,0,0,0.35), rgba(0,0,0,0.35)), url(${banner.image.url})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }
    : {
        background: 'linear-gradient(135deg, #1B3A63 0%, #6B1420 100%)',
      };

  const go = () => {
    if (banner.link) navigate(banner.link);
  };

  return (
    <div
      style={{
        position: 'relative',
        width: '100%',
        minHeight: '64px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        cursor: banner.link ? 'pointer' : 'default',
        ...backgroundStyle,
      }}
      onClick={go}
      role={banner.link ? 'link' : undefined}
    >
      <div style={{ textAlign: 'center', padding: '10px 40px', maxWidth: '900px' }}>
        {banner.title && (
          <div
            style={{
              color: '#fff',
              fontWeight: 700,
              fontSize: '0.95rem',
              textShadow: '0 1px 4px rgba(0,0,0,0.4)',
              textTransform: 'uppercase',
              letterSpacing: '0.3px',
            }}
          >
            {banner.title}
          </div>
        )}
        {banner.subtitle && (
          <div
            style={{
              color: 'rgba(255,255,255,0.92)',
              fontSize: '0.78rem',
              textShadow: '0 1px 3px rgba(0,0,0,0.4)',
              marginTop: '3px',
            }}
          >
            {banner.subtitle}
          </div>
        )}
        {banner.showButton && banner.buttonText && (
          <button
            onClick={(e) => {
              e.stopPropagation();
              go();
            }}
            style={{
              marginTop: '7px',
              padding: '7px 20px',
              border: 'none',
              borderRadius: '999px',
              background: '#fff',
              color: '#6B1420',
              fontWeight: 700,
              fontSize: '0.8rem',
              cursor: 'pointer',
              boxShadow: '0 2px 10px rgba(0,0,0,0.25)',
            }}
          >
            {banner.buttonText}
          </button>
        )}
      </div>

      {banners.length > 1 && (
        <>
          <button
            aria-label="Previous banner"
            onClick={(e) => {
              e.stopPropagation();
              setIndex((prev) => (prev - 1 + banners.length) % banners.length);
            }}
            style={{
              position: 'absolute',
              left: 0,
              top: 0,
              bottom: 0,
              width: '34px',
              background: 'rgba(0,0,0,0.15)',
              border: 'none',
              color: '#fff',
              cursor: 'pointer',
              fontSize: '0.8rem',
            }}
          >
            <FaChevronLeft />
          </button>
          <button
            aria-label="Next banner"
            onClick={(e) => {
              e.stopPropagation();
              setIndex((prev) => (prev + 1) % banners.length);
            }}
            style={{
              position: 'absolute',
              right: 0,
              top: 0,
              bottom: 0,
              width: '34px',
              background: 'rgba(0,0,0,0.15)',
              border: 'none',
              color: '#fff',
              cursor: 'pointer',
              fontSize: '0.8rem',
            }}
          >
            <FaChevronRight />
          </button>
          <div
            style={{
              position: 'absolute',
              bottom: '5px',
              left: 0,
              right: 0,
              display: 'flex',
              justifyContent: 'center',
              gap: '5px',
            }}
          >
            {banners.map((_, i) => (
              <button
                key={i}
                aria-label={`Go to banner ${i + 1}`}
                onClick={(e) => {
                  e.stopPropagation();
                  setIndex(i);
                }}
                style={{
                  width: '7px',
                  height: '7px',
                  borderRadius: '50%',
                  border: 'none',
                  padding: 0,
                  cursor: 'pointer',
                  background: i === index ? '#fff' : 'rgba(255,255,255,0.5)',
                }}
              />
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default TopDiscountBanner;